exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".simple-header-background .bg{background-repeat:no-repeat;background-size:contain;left:0;top:0}@media (min-width:992px){.simple-header-background .bg{background-position:50%;background-size:cover}}", ""]);

